import { createSlotRecipe } from './runtime.js';

const captionConfig = {"name":"caption","slots":["root","item","avatar","icon","text","count"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl"]}}

export const caption = /* @__PURE__ */ createSlotRecipe(captionConfig)